import {formatDate, formatOrderAddress, formatPrice, parseToken} from "./UtilityService";

export const getOrderData = (params) => {
    const {token = ''} = params;
    const tokenData = parseToken(token);

    return mapOrderDetails(tokenData);
};

const mapOrderDetails = (order) => {
    const items = order.product_details.map((i) => ({
        id: i.products_id,
        name: i.products_name,
        image: i.image,
        quantity: i.products_quantity,
        item_price: formatPrice(parseFloat(i.final_price)),
        total_price: formatPrice(parseFloat(i.final_price) * i.products_quantity),
    }));
    const shippingAddress = order.order_details.delivery_country
        ? {
            name: order.order_details.delivery_name,
            company: order.order_details.delivery_company,
            street: order.order_details.delivery_street_address,
            location: formatOrderAddress(order, 'delivery'),
            country: order.order_details.delivery_country,
        }
        : null;

    const billingAddress = {
        name: order.order_details.billing_name ? order.order_details.billing_name.trim() : '',
        company: order.order_details.billing_company,
        street: order.order_details.billing_street_address,
        location: formatOrderAddress(order, 'billing'),
        country: order.order_details.billing_country,
        phone: order.order_details.billing_phone,
    };
    const history = order.history.map((h, i) => {
        const notes = [];
        if (h.status) {
            notes.push(h.status);
        }
        if (h.comments) {
            notes.push(h.comments);
        }
        return {
            id: i,
            changedAt: formatDate(h.date_added, 'MMMM DD YYYY, hh:mm A'),
            notes: notes.join(' - '),
        };
    });

    let coupon_code = order.order_details.coupon_code;

    if (!coupon_code && order.ot_coupon && order.ot_coupon.title) {
        const coupon = order.ot_coupon.title.split(':')[1];
        if (coupon) {
            coupon_code = coupon.replace(' ', '');
        } else {
            coupon_code = order.ot_coupon.title.replace(':', '');
        }
    }

    return {
        id: order.order_details.orders_id,
        status: order.order_details.status,
        payment_method: order.order_details.payment_method,
        po_authorizer: order.order_details.po_authorizer,
        po_number: order.order_details.po_number,
        vat_number: order.order_details.vat_number ? String(order.order_details.vat_number) : null,
        shipping_method: order.ot_shipping ? order.order_details.shipping_method : '',
        date_purchased: formatDate(order.order_details.date_purchased, 'MMMM DD YYYY, hh:mm A'),
        items,
        shippingAddress,
        billingAddress,
        totals: {
            subtotal: formatPrice(
                order.ot_subtotal && parseFloat(order.ot_subtotal.value) > 0 ? parseFloat(order.ot_subtotal.value) : 0
            ),
            discount: formatPrice(
                order.ot_coupon && parseFloat(order.ot_coupon.value) > 0 ? parseFloat(order.ot_coupon.value) : 0
            ),
            discountValue: order.ot_coupon && order.ot_coupon.value ? parseFloat(order.ot_coupon.value) : 0,
            tax: formatPrice(
                order.ot_tax && parseFloat(order.ot_tax.value) > 0 ? parseFloat(order.ot_tax.value) : 0
            ),
            shipping: formatPrice(
                order.ot_shipping && parseFloat(order.ot_shipping.value) > 0 ? parseFloat(order.ot_shipping.value) : 0
            ),
            total: formatPrice(
                order.ot_total && parseFloat(order.ot_total.value) > 0 ? parseFloat(order.ot_total.value) : 0
            ),
            coupon_code,
        },
        history,
        order_tracking_details: order.order_tracking_details,
    };
};

export default {
    getOrderData,
}